import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
const Footer = dynamic(() =>
  import('presentations/views/components/organisms/Footer'),
);
const ContentFooter = dynamic(() =>
  import('presentations/views/components/organisms/ContentFooter'),
);
import styled from '@emotion/styled';
import { spacing, mediaMax } from 'presentations/views/styles';
import {
  background,
  black,
  gray04,
  white,
} from 'presentations/views/styles/color';
import { LocalCampaign, useSourceTrack } from 'presentations/views/hooks/track';

interface Props {
  header: ReactNode;
  children: ReactNode;
  breadcrumbs?: ReactNode;
  contentHeader?: ReactNode;
  campaign?: LocalCampaign;
}
export default function Component(props: Props) {
  useSourceTrack(props.campaign);
  return (
    <MainContainer>
      {props.header}
      {props.contentHeader && (
        <ContentHeader>{props.contentHeader}</ContentHeader>
      )}
      {/* {props.title && (
        <ContentHeader>
          <HeaderIcon name="description" className="material-icons-outlined" />
          <HeaderTitle>{props.title}</HeaderTitle>
        </ContentHeader>
      )} */}
      {props.breadcrumbs}
      <Main>{props.children}</Main>
      <ContentFooterContainer>
        <ContentFooter />
      </ContentFooterContainer>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </MainContainer>
  );
}
const Main = styled.div``;

export const MainContainer = styled.div`
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  background-color: ${background};
  color: ${black};
`;
export const FooterContainer = styled.div`
  width: 100%;
  position: relative;
`;
const ContentHeader = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  background-color: ${white};
  ${mediaMax.desktop} {
    padding: 0 ${spacing(24)};
  }
  ${mediaMax.xs} {
    width: 100%;
  }
`;

export const ContentFooterContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${spacing(48)} 0;
  border-top: 1px solid ${gray04};
  border-bottom: 1px solid ${gray04};
`;
